export default {
  xs: "320px",
  sm: "768px",
  md: "1024px",
  lg: "1280px",
  "lg+": "1440px",
  xl: "1920px"
};
